module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label for="'+
((__t=( selectId ))==null?'':_.escape(__t))+
'" class="import_filter">'+
((__t=( labelText ))==null?'':_.escape(__t))+
'</label>\n<select id="%- selectId %>" class="import_filter"></select>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/attribute_filter.html
// module id = 209
// module chunks = 0